module.exports = __webpack_public_path__ + "static/media/TT_Tagdyrlar_Taitalasy_Book2_2021_sc_watermark.0ec17c48.pdf";